// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import telegramReducer from './slices/telegramSlice';
import settingsReducer from './slices/settingsSlice';
import gameDataReducer from './slices/gameDataSlice';
import galleryReducer from './slices/gallerySlice';
import notificationsReducer from './slices/notificationsSlice';
import userLevelReducer from './slices/userLevelSlice';
import appReducer from './slices/appSlice';

const initialState = {
    resetCache: false,
    channelCreated: false,
    channelDeleted: false,
    channelUpdated: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'RESET_CACHE':
            return { ...state, resetCache: true };
        case 'SET_CHANNEL_CREATED':
            return { ...state, channelCreated: action.payload };
        case 'SET_CHANNEL_DELETED':
            return { ...state, channelDeleted: action.payload };
        case 'SET_CHANNEL_UPDATED':
            return { ...state, channelUpdated: action.payload };
        default:
            return state;
    }
};

export const store = configureStore({
    reducer: {
        auth: authReducer,
        telegram: telegramReducer,
        settings: settingsReducer,
        gameData: gameDataReducer,
        gallery: galleryReducer,
        notifications: notificationsReducer,
        userLevel: userLevelReducer,
        app: appReducer
    }
});
